import { useTranslation } from 'react-i18next'

const DEFAULT_CLASS_NAME_LABEL = 'membership.default.class.name'

const useDefaultClassName = () => {
  const { t } = useTranslation()

  const getTranslatedName = (name: string) => {
    if (name === DEFAULT_CLASS_NAME_LABEL) {
      return t('view_as.class.default_class')
    }

    return name
  }

  return { getTranslatedName }
}

export default useDefaultClassName
